import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles((theme) => ({
  big: {
    position: 'fixed', // Ensures it stays in place regardless of scrolling
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)', // Centers it properly
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100px',
    height: '100px',
    zIndex: 9999, // Ensures it appears on top of other elements
    backgroundColor: 'transparent', // Avoid blocking interactions with elements underneath
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
  small: {
    justifyContent: 'center', // Centers horizontally
    alignItems: 'center', // Centers vertically
    height: '100%', // Ensures the parent container's height is used
    width: '100%',
    display: 'flex',
    '& > * + *': {
      marginLeft: theme.spacing(2),
    },
  },
}));

const CircularLoading = (props) => {
  const { big = true } = props
  const classes = useStyles();

  return (
    <div className={big ? classes.big : classes.small}>
      <CircularProgress size={60}/>
    </div>
  );
}

export default CircularLoading;